import store from "../store/index";
import { message } from 'ant-design-vue'
import { getSiteInfo } from "@/storage/site_info";
import { getAccessToken } from "@/storage/token";

const loginRoutePath = '/auth/login'
const defaultRoutePath = '/'
const notPermissionRoutePath = '/403'

const beforeEach = (to, from, next) => {
  // 设置页面标题
  if (to.meta && typeof to.meta.title !== 'undefined') {
    setDocumentTitle(to.meta.title)
  } else {
    const siteInfo = getSiteInfo()
    setDocumentTitle(siteInfo.site_name)
  }

  /* has token */
  const token = getAccessToken()
  if (token) {
    if (to.path === loginRoutePath) {
      next({ path: defaultRoutePath })
      return
    }

    // 检查用户的登录状态，并获取基础信息
    if (!store.state.user.nickname) {
      // request login userInfo
      store
          .dispatch('GetInfo')
          .then(res => {
            checkPermissionGo(to, from, next)
          })
          .catch(() => {
            message.error({
              content: '请求用户信息失败，请重试'
            })
            // 失败时，获取用户信息失败时，调用登出，来清空历史保留信息
            store.dispatch('Logout').then(() => {
              next({ path: loginRoutePath, query: { redirect: to.fullPath } })
            })
          })
    } else {
      checkPermissionGo(to, from, next)
    }
  } else {
    if (!to.meta.auth || to.meta.auth === 'public') {
      // 在免登录名单，直接进入
      next()
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath } })
    }
  }
}

const checkPermissionGo = (to, from, next) => {

  let isPass = false
  if (!to.meta.auth || to.meta.auth === 'public' || (to.meta.auth === 'sign' && store.state.user.nickname)) {
    // 在授权名单，通过校验
    isPass = true
  }

  if (isPass) {
    // 请求带有 redirect 重定向时，登录自动重定向到该地址
    const redirect = decodeURIComponent(from.query.redirect || to.path)
    if (to.path === redirect) {
      // set the replace: true so the navigation will not leave a history record
      next()
    } else {
      // 跳转到目的路由
      next({ path: redirect })
    }
  } else {
    next({ path: notPermissionRoutePath })
  }
}

const afterEach = () => {
}


const setDocumentTitle = (title) => {
  document.title = title
  const ua = navigator.userAgent
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement('iframe')
    i.src = '/favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
}

export { beforeEach, afterEach }
